// extracted by mini-css-extract-plugin
export default {"wrapper":"BaseInput_wrapper__p8JQD","error":"BaseInput_error__CpJ+1","group":"BaseInput_group__IGu7N","placeholder":"BaseInput_placeholder__fPP7L","active":"BaseInput_active__47WZf"};